<template>
<div>
    <pt-sub-title-tab :data="couponStateTabs" v-model="slectInviteTab"></pt-sub-title-tab>
    <wt-paged-table :on-request-data="getTableData" :total-size="totalNumber"
         :page-size="pageSize" ref="table" v-loading="tableLoading"  :class="$style['customer-coupon-table']">
            <wt-table :list="tableData" :labels="tableLables">
                <template>
                    <el-table-column label="内容">
                        <template slot-scope="scope">
                            {{scope.row.discount_show}}<br/>
                            满{{scope.row.threshold_of_amount}}元可使用
                        </template>
                    </el-table-column>
                    <el-table-column label="有效期">
                        <template slot-scope="scope">
                            {{scope.row.validity_date}}
                        </template>
                    </el-table-column>
                    <el-table-column label="发布方式">
                        <template slot-scope="scope">
                            {{scope.row.publishType}}
                        </template>
                    </el-table-column>
                    <el-table-column label="使用状态">
                        <template slot-scope="scope">
                            <div :class="scope.row.useStatus==='USED'?$style.useStatusUsed:''">{{scope.row.use_status}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column label="状态/操作">
                    <template slot-scope="scope">
                        {{scope.row.coupon_status}}<br/>
                        <el-button type="text" @click="getCouponDetail(scope.row)">详情</el-button>
                        <el-button type="text" v-if="scope.row.useStatus==='GOT'"  @click="signUsed(scope.row)">标记为已使用</el-button>
                    </template>
                    </el-table-column>
                </template>
            </wt-table>
    </wt-paged-table>
</div>
</template>
<script>
import { couponStateTabs, customerCouponTableLabels } from './customer-detail-option'
export default {
  props: {
    userId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      couponStateTabs: couponStateTabs,
      slectInviteTab: 'ALL',
      pageSize: 10,
      tableLoading: false,
      tableData: [],
      totalNumber: 0,
      tableLables: customerCouponTableLabels,
      page: 0
    }
  },
  watch: {
    slectInviteTab (val) {
      this.$refs.table.resetPage()
    }
  },
  methods: {
    getTableData (page, next) {
      this.page = page
      let data = {
        pageableParam: {
          page: page,
          size: this.pageSize
        },
        userId: this.userId,
        queryType: this.slectInviteTab === 'ALL' ? null : this.slectInviteTab
      }
      if (!next) {
        this.tableLoading = true
      }
      this.$store.dispatch('mallUserCoupons', data).then(res => {
        this.tableData = res.data
        this.totalNumber = res.totalNumber
        if (next) {
          next(res.data)
        } else {
          this.tableLoading = false
        }
      }).catch(err => {
        this.tableLoading = false
        this.$message.error(err || '获取用户优惠劵失败')
      })
    },
    getCouponDetail (row) {
      this.$emit('getCouponDetail', row.discountCouponId)
    },
    signUsed (row) {
      this.$confirm('是否确定将该优惠劵标记为已使用，该操作不可撤回', '标记提示', {
        confirmButton: '确定',
        cancelButton: '取消',
        type: 'warning'
      }).then(_ => {
        this.couponUsed(row.id)
      })
    },
    couponUsed (id) {
      this.$store.dispatch('couponUsed', id).then(res => {
        this.$message.success('标记优惠劵成功')
        this.getTableData(this.page)
      }).catch(err => {
        this.$message.error(err || '标记优惠劵失败')
      })
    }
  },
  created () {
    this.$emit('mallUserDetail')
  }
}
</script>
<style module lang="less">
.customer-coupon-table{
    :global
    .el-button{
        margin-left: 0!important;
        margin-right: 10px;
    }
}
.useStatusUsed{
    color: #edbe81
}
</style>
